module.exports = wp.keycodes;